import { render, staticRenderFns } from "./OmniCardHeader.vue?vue&type=template&id=4073cbe2&"
import script from "./OmniCardHeader.vue?vue&type=script&lang=js&"
export * from "./OmniCardHeader.vue?vue&type=script&lang=js&"
import style0 from "./OmniCardHeader.vue?vue&type=style&index=0&id=4073cbe2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports